import { render, staticRenderFns } from "./config.vue?vue&type=template&id=1360441e&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"
import style0 from "./config.vue?vue&type=style&index=0&id=1360441e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1360441e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1360441e')) {
      api.createRecord('1360441e', component.options)
    } else {
      api.reload('1360441e', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=1360441e&scoped=true", function () {
      api.rerender('1360441e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechats/config.vue"
export default component.exports